// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37RAh","location":"Header_location__2mu7M"};